<template>
    <div>
        <div class="table-values flex flex-nowrap justify-around p-4 pl-11 pt-3 bg-white overflow-x-auto border-b border-[#D9D5EC]" :class="{'bg-[#F2F0F9]' : selected || showactions }">
            <p class="w-3/12 overflow-wrap">{{ shipping.shippingReference }}</p>
            <p class="w-3/12 ml-2">{{ consolidationReference }}</p>
            <p class="w-3/12 ml-2">{{ count }}/{{ total }}</p>
            <p class="w-5/12 ml-2 overflow-wrap break-words">{{ getDescription }}</p>
            <p class="w-3/12 ml-2">{{ getLoadWeight }} Kg</p>
            <p class="w-3/12 ml-2 overflow-wrap">{{ shipping.shippingservice.orgName }}</p>
            <p class="w-4/12 ml-2">{{ getSpecialHandling }}</p>
            <p class="w-4/12 ml-2 break-all"></p>
        </div>

    </div>
    
</template>

<script>


export default {
    components : {
    },
    props : ['shipping', 'count', 'total', "consolidationReference"],
    data(){
        return {
            showactions : false,
            statusDispatch : false,
            putholdModal : false,
            showfinalholdmodal : false,
            successfulDispatch : false,
            showupdateModal : false,
            processhandoffModal :false,
            showProcessFulfillmentModal : false,
            confirmprocesshandoffModal : false,
            requestsentModal : false,
            processreturnmodal : false,
            returndetailsmodal : false,
            returncostmodal : false,
            canceldispatchshow : false,
            putonholdreason : "",
            booking : {}
        }
    },
    mounted(){
        console.log(this.shipping)
    },
    methods : {
        capitalize(str){
            let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

            return capitalizedstr
        },
        showModal(modal){

            if(modal == 'dispatchmodal'){
                this.statusDispatch = true
            }else if(modal == 'putonholdmodal'){
                this.putholdModal = true
            }else if(modal == 'statusmodal'){
                this.showupdateModal = true
            }else if(modal == 'processhandoffmodal'){
                this.processhandoffModal = true
            }else if(modal == 'processreturnModal'){
                this.processreturnmodal = true
            }else if(modal == 'canceldispatch'){
                this.canceldispatchshow = true
            }
        },
        
    },
    computed : {
        onDispatch(){
            return this.shipping.dispatchStatus == 'dispatched' || this.shipping.dispatchStatus == 'accidented' || this.shipping.dispatchStatus == 'received' || this.shipping.dispatchStatus == 'delayed' ? true : false
        },
        getLoadWeight(){
            let weight = 0
            this.shipping.packagees.forEach(x => {
                weight += (x.estimatedWeight * x.quantity)
            })

            return weight 
        },
        getSpecialHandling(){
            let handling = ""
            this.shipping.packagees.forEach((x,y) => {
                handling += x.specialHandling.toString()
                if(this.shipping.packagees.length <= y){
                    handling += ","
                }
                
            })

            return handling
        },
        getDescription(){
            let description = ""
            this.shipping.packagees.forEach((x,y) => {
                description += x.description.toString()
                if(this.shipping.packagees.length <= y){
                    description += ","
                }
                
            })

            return description
        }
    }
}
</script>

<style lang="scss" scoped>

.table-values{
    p{
        font-weight: 500;
    }
    .status-green{
        background-color : #09B78A33;
        color : #09B78A;
        font-size: 14px
    }
    .status-yellow{
        background-color: #FFA60033;
        color : #FFA600;
        font-size : 14px
    }
    .status-pale{
        background-color: #10233E33;
        color : #10233E;
        font-size : 14px
    }
    .status-any{
        background-color: #FFA60033;
        color : #FFA600;
        font-size: 14px
    }
    .status-red{
        background-color: #D7263833;
        color: #D72638;
        font-size: 14px;
    }
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
}
</style>